import { DescripteursSyllabus } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierDescripteursSyllabusObjetMaquetteCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private oldDescripteursSyllabus: DescripteursSyllabus,
        private newDescripteursSyllabus: DescripteursSyllabus
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursSyllabusObjetMaquette(this.id, this.version, this.newDescripteursSyllabus)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursSyllabusObjetMaquette(this.id, this.version, this.oldDescripteursSyllabus)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
